import randomIntFromInterval from "./randomIntFromInterval";

Array.prototype.getRandom = function () {
    //生成从0至数组最后一项的随机数
    const id = randomIntFromInterval(0, this.length - 1)
    //取出这一项
    return this[id];
}